import { render } from "./PalliativeTeamDetail.vue?vue&type=template&id=5ec902d6&scoped=true"
import script from "./PalliativeTeamDetail.vue?vue&type=script&lang=js"
export * from "./PalliativeTeamDetail.vue?vue&type=script&lang=js"

import "./PalliativeTeamDetail.vue?vue&type=style&index=0&id=5ec902d6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ec902d6"]])

export default __exports__